import ClearFilledSVG from './icon_clear_filled.svg';
import withIconProps from './withIconProps';

export default withIconProps(ClearFilledSVG);
